import { Controller } from "@hotwired/stimulus"

// Document-specific bulk actions (W5-6 / RES-110).
// Composes with `selection` controller (data-controller="selection document-bulk-actions").
// Selection handles the checkbox + toolbar wiring; this controller only handles
// the document-specific actions (bulkDelete, bulkRetry).
//
// Reads selected IDs from `[data-selection-target="checkbox"]:checked`
// so it stays in sync with the selection controller without coupling.
export default class extends Controller {
  static values = {
    establishmentId: String
  }

  async bulkDelete(event) {
    event.preventDefault()

    const ids = this.selectedIds
    if (ids.length === 0) return

    const count = ids.length
    const confirmMessage = `Êtes-vous sûr de vouloir supprimer ${count} document${count > 1 ? "s" : ""} ?`
    if (!confirm(confirmMessage)) return

    try {
      const response = await fetch(
        `/establishments/${this.establishmentIdValue}/documents/bulk_destroy`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": this.csrfToken
          },
          body: JSON.stringify({ document_ids: ids })
        }
      )

      if (response.ok) {
        window.location.reload()
      } else {
        const data = await response.json()
        alert(data.error || "Une erreur est survenue lors de la suppression")
      }
    } catch (error) {
      console.error("Error:", error)
      alert("Une erreur est survenue lors de la suppression")
    }
  }

  async bulkRetry(event) {
    event.preventDefault()

    const ids = this.selectedIds
    if (ids.length === 0) return

    const count = ids.length
    const confirmMessage = `Êtes-vous sûr de vouloir relancer l'extraction pour ${count} document${count > 1 ? "s" : ""} ?`
    if (!confirm(confirmMessage)) return

    try {
      const response = await fetch(
        `/establishments/${this.establishmentIdValue}/documents/bulk_retry`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": this.csrfToken
          },
          body: JSON.stringify({ document_ids: ids })
        }
      )

      if (response.ok) {
        const data = await response.json()
        if (data.message) alert(data.message)
        window.location.reload()
      } else {
        const data = await response.json()
        alert(data.error || "Une erreur est survenue lors du relancement")
      }
    } catch (error) {
      console.error("Error:", error)
      alert("Une erreur est survenue lors du relancement")
    }
  }

  // ---- internals --------------------------------------------------------

  get selectedIds() {
    return Array.from(
      this.element.querySelectorAll('[data-selection-target="checkbox"]:checked')
    ).map((cb) => cb.value)
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
